import { QUALIFICATION_CODE } from './qualification.constants';

export const DEPENDENCY_MATCH_CRITERIA = {
  IN: 'in',
  NOT_IN: 'nin',
} as const;

export const UNSUPPORTED_ADVANCED_TARGETING_PARENT_CODES: ReadonlySet<number> =
  new Set([QUALIFICATION_CODE.RACE]);

export const ADVANCED_TARGETING_QUALIFICATION_NAME_TOKEN =
  '<QUALIFICATION_NAME>';

export const ADVANCED_TARGETING_CONFIRMATION = {
  CORE_DEPENDENCY: `The qualification you have added has a dependency on ${ADVANCED_TARGETING_QUALIFICATION_NAME_TOKEN}. To prevent conflicts, that qualification will reset.`,
  CORE_DEPENDENCY_EXISTS:
    'You are attempting to add a qualification with a dependency. The new qualification is causing a conflict with other selections that you have made. Please check your selected qualifications and the associated dependencies to avoid conflicts.',
  DELETE_CORE_DEPENDENCY: `Clearing this qualification will also reset the qualification on ${ADVANCED_TARGETING_QUALIFICATION_NAME_TOKEN}.`,
} as const;

export const UNSUPPORTED_PARENT_QUALIFICATION_MESSAGE =
  'You are attempting to add a qualification having a dependency that we currently do not support in our system. Please check your selection and try again.';
